export default {
  props: {
    visible: {
      type: Boolean,
      default: true,
    },
    cameras: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      requestLoading: false,
    };
  },
  methods: {
    onClose() {
      this.$emit("update:visible", false);
    },
    save(cb) {
      this.requestLoading = true;
      return cb()
        .then((resp) => {
          // TODO Добавить отображение количества успешно измененных записей
          this.$message.success("Камеры успешно обновлены");
          this.$emit("updated", resp);
        })
        .catch((e) => {
          this.$message.error(e.response?.data?.error || "Произошла ошибка при обновлении камер");
        })
        .finally(() => {
          this.requestLoading = false;
        });
    },
  },
};
